import { zodResolver } from '@hookform/resolvers/zod';
import { NewBillingCycleSchema } from '@weft/types';
import type { NewBillingCycle } from '@weft/types';
import { Table } from 'antd';
import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useForm, FormProvider } from 'react-hook-form';
import { withSuspenseBoundary } from '../../components/utility/SuspenseBoundary';
import { useBillingCyclesOverview } from '../../hooks/requests/use-billing-cycle-overview/use-billing-cycle-overview';
import { useVyNavigate } from '../../hooks/use-vy-navigate';
import { getBillingCycleColumns } from './billing-cycle-components/BillingCycleOverviewColumns';
import { BillingCycleOverviewHeader } from './billing-cycle-components/BillingCycleOverviewHeader';
import { NewBillingCycleInitialValues } from './billing-cycle-consts/billing-cycle-input-initial-values';
import { BILLING_CYCLE_TABLE_DEFAULT_PAGE_SIZE } from './billing-cycle-consts/billing-cycle-table-page-size';

const BillingCycleOverviewPage = () => {
  const navigate = useVyNavigate();

  const methods = useForm<NewBillingCycle>({
    resolver: zodResolver(NewBillingCycleSchema),
    defaultValues: NewBillingCycleInitialValues,
  });

  const columns = useMemo(() => {
    return getBillingCycleColumns();
  }, []);

  const { data } = useBillingCyclesOverview();

  const billingCycles = data?.billingCycles;

  return (
    <>
      <Helmet>
        <title>Billing Settings</title>
      </Helmet>
      <FormProvider {...methods}>
     
        <BillingCycleOverviewHeader />      
        <div className="px-8 py-10">
          <Table
            className='text-label font-sans text-black [&_.ant-table-column-sorter]:hidden'
            columns={columns}
            rowKey="id"
            dataSource={billingCycles}
            pagination={{
              defaultPageSize: BILLING_CYCLE_TABLE_DEFAULT_PAGE_SIZE,
              hideOnSinglePage: true,
            }}
            showSorterTooltip={false}
            onHeaderRow={() => ({
              className: '[&_.ant-table-cell]:!bg-white [&_.ant-table-cell]:!pl-4 [&_.ant-table-cell]:before:hidden text-black',
            })}
            onRow={({ id }) => ({
              className: '[&_.ant-table-cell]:!bg-white cursor-pointer [&_.ant-table-cell]:hover:!bg-white text-black',
              onClick: () => navigate(`/invoices/billing-settings/${id}`),
            })}
          />
        </div>
      </FormProvider>
    </>
  );
};

const BillingCycleOverviewPageWithSuspenseBoundary = withSuspenseBoundary(BillingCycleOverviewPage);

export { BillingCycleOverviewPageWithSuspenseBoundary as BillingCycleOverviewPage };